export default __webpack_public_path__ + "static/media/002-atom.1ddb86c5.png";